module.exports = __webpack_public_path__ + "img/trustpilot_star_white.90f38ee7.png";